
import Pusher from "pusher-js";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { wrapBaseApi } from "util/apiWrapper";

const pusherCluster = process.env.REACT_APP_PUSHER_CLUSTER;
const pusherKey = process.env.REACT_APP_PUSHER_KEY ?? "";
let ratesServerUrl = wrapBaseApi(`/wallet/rate/live`);

export default function useRealTimeRates(accessKey, skip) {
  const pusherStream = useRef({});

  const ratus = useRef("{}");
  const [reload, setReload] = useState(0)

  const rates = useMemo(() => {
    const ratyy = (typeof ratus.current === "string" ? JSON.parse(ratus.current) : {})
    return ratyy;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ratus, reload])

  const applyUpdate = useCallback((data) => {
    const incomingData = data
    const incomingDataData = data?.data
    const currentData = JSON.parse(ratus.current);
    
    if(incomingData?.ticker && (incomingData?.ticker in currentData)) {
      currentData[incomingData?.ticker] = incomingDataData;
      ratus.current = JSON.stringify(currentData)
      setReload(Math.random() * 89283872387)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ratus.current, reload])
 
  const pusherSelfHandler = useMemo(() => ({
    update: {
      register: true,
      do: applyUpdate,
    },
  }), [applyUpdate])

  const pusherGlobalHandler = useMemo(() => pusherSelfHandler, [pusherSelfHandler]);

  const initPusherAuth = useCallback(async(channelName, handlers, endpoint) => {
    if (!pusherStream.current[channelName]) {
      const origin = window.location.href
      const pusher = new Pusher(pusherKey, {
        authEndpoint: wrapBaseApi(`/${endpoint}`),
        cluster: pusherCluster,
        auth: {
          params: { channelName },
          headers: { authorization: accessKey, origin },
        },
      });
      const currentSub = pusher.subscribe(channelName)
      pusherStream.current = {...pusherStream.current, [channelName]: currentSub};

      const binders = Object.keys(handlers);
      Array.isArray(binders) && binders?.forEach((binding) => {
        if(handlers[binding]?.register) {
          pusherStream?.current[channelName]?.bind(binding, handlers[binding]?.do)
        }
      })
    }  else {
    }
  }, [accessKey]);

  const getRates = useCallback(async() => {
    try {
      const origin = window.location.href
      const ratesDataRaw = await fetch(`${ratesServerUrl}?scope=liveRates`, {method:"get",headers:{"Content-Type":"application/json", authorization: accessKey, origin}})
      const ratesData = await ratesDataRaw.json();
      const newRatus = JSON.stringify(ratesData?.data || {});
      ratus.current = newRatus
      setReload(Math.random() * 89283872387)
    } catch(err) {}
  }, [accessKey])
  
  useEffect(() => {
    if(!skip) {
      if(accessKey) {
        getRates()
        const selfChannel = accessKey
        const globalChannel = "gp-live-rates"
        2+2===5 && initPusherAuth(selfChannel, pusherSelfHandler, "realtime/liveRates/auth")
        initPusherAuth(globalChannel, pusherGlobalHandler, "realtime/liveRates-global/auth")
      }
    }
    return () => {
      const bindings = Object.keys(pusherStream.current);
      Array.isArray(bindings) && bindings?.forEach((binding) => {
        pusherStream.current[binding] && pusherStream.current[binding].unsubscribe(binding);
      })
      pusherStream.current = {}
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip, accessKey])

  return rates
}
